export const BLACKLIST_EMAILER_FILTERS = {
  learnerEmail: 'learnerEmail',
  superBatch: 'superBatch',
};
